module.exports = __webpack_public_path__ + "media/images/logo/gigbase_logo-white-55faf1419fb04cf3ba07a9d81cf68e9b.svg";